const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const SESSION_KEY = "elm_stage_funnel_session";
const CONSENT_KEY = "elm_measurement_consent";
const CLIENT_KEY = "elm_measurement_client";
const EVENTS = new Set(["view_drum_stage_page", "start_drum_booking", "click_group_dates", "click_individual_booking", "choose_stage_mode", "select_stage_date", "configure_stage_started", "reach_stage_contact", "reach_stage_payment", "submit_stage_booking", "checkout_created", "complete_drum_booking", "stage_booking_error"]);
const FIELDS = ["source", "mode", "event_id", "participants", "payment"];
const validGoogleAds = (tag, label) => /^AW-\d+$/.test(tag || "") && /^[A-Za-z0-9_-]{4,}$/.test(label || "");

export const funnelSessionId = () => {
  if (typeof window === "undefined") return null;
  let session = window.sessionStorage.getItem(SESSION_KEY);
  if (!session) {
    session = window.crypto?.randomUUID?.() || `${Date.now().toString(36)}_${Math.random().toString(36).slice(2)}`;
    window.sessionStorage.setItem(SESSION_KEY, session);
  }
  return session.replace(/[^A-Za-z0-9_-]/g, "_").slice(0, 64);
};

export const hasMeasurementConsent = () => typeof window !== "undefined" && window.localStorage.getItem(CONSENT_KEY) === "granted";
export const hasMeasurementDecision = () => typeof window !== "undefined" && ["granted", "denied"].includes(window.localStorage.getItem(CONSENT_KEY));

const installGoogleTags = () => {
  const gaId = process.env.REACT_APP_GA4_MEASUREMENT_ID;
  const adsId = process.env.REACT_APP_GOOGLE_ADS_TAG_ID;
  if (!gaId || typeof window === "undefined" || !hasMeasurementConsent()) return;
  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function gtag() { window.dataLayer.push(arguments); };
  window.gtag("consent", "default", { analytics_storage: "denied", ad_storage: "denied", ad_user_data: "denied", ad_personalization: "denied" });
  window.gtag("consent", "update", { analytics_storage: "granted", ad_storage: "granted", ad_user_data: "granted", ad_personalization: "granted" });
  window.gtag("js", new Date());
  window.gtag("config", gaId);
  if (/^AW-\d+$/.test(adsId || "")) window.gtag("config", adsId);
  if (!document.querySelector("script[data-elm-google-tags]")) {
    const script = document.createElement("script");
    script.async = true; script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(gaId)}`; script.dataset.elmGoogleTags = "true";
    document.head.appendChild(script);
  }
};

export const applyGoogleConsent = (granted) => {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(CONSENT_KEY, granted ? "granted" : "denied");
  if (granted) installGoogleTags();
  else if (typeof window.gtag === "function") window.gtag("consent", "update", { analytics_storage: "denied", ad_storage: "denied", ad_user_data: "denied", ad_personalization: "denied" });
};

export const initializeMeasurement = () => { if (hasMeasurementConsent()) installGoogleTags(); };

export const measurementBookingData = () => {
  if (!hasMeasurementConsent()) return { analytics_consent: false };
  let clientId = window.localStorage.getItem(CLIENT_KEY);
  if (!clientId) { clientId = window.crypto?.randomUUID?.() || funnelSessionId(); window.localStorage.setItem(CLIENT_KEY, clientId); }
  return { analytics_consent: true, analytics_client_id: clientId.slice(0, 100) };
};

export const trackGoogleAdsConversion = ({ transactionId, value }) => {
  const tag = process.env.REACT_APP_GOOGLE_ADS_TAG_ID;
  const label = process.env.REACT_APP_GOOGLE_ADS_CONVERSION_LABEL;
  if (!hasMeasurementConsent() || !validGoogleAds(tag, label) || typeof window.gtag !== "function" || !transactionId) return;
  const key = `elm-ads-conversion-${transactionId}`;
  if (window.sessionStorage.getItem(key)) return;
  window.gtag("event", "conversion", { send_to: `${tag}/${label}`, value: Number(value) || 0, currency: "CHF", transaction_id: transactionId });
  window.sessionStorage.setItem(key, "sent");
};

const sendInternal = (name, params) => {
  if (!EVENTS.has(name)) return;
  const body = { session_id: funnelSessionId(), event: name, page: window.location.pathname };
  FIELDS.forEach((field) => { if (params[field] != null) body[field] = params[field]; });
  const payload = JSON.stringify(body);
  if (navigator.sendBeacon) {
    const accepted = navigator.sendBeacon(`${API}/analytics/funnel`, new Blob([payload], { type: "application/json" }));
    if (accepted) return;
  }
  fetch(`${API}/analytics/funnel`, { method: "POST", headers: { "Content-Type": "application/json" }, body: payload, keepalive: true }).catch(() => {});
};

export const track = (name, params = {}) => {
  try {
    if (typeof window === "undefined") return;
    sendInternal(name, params);
    if (hasMeasurementConsent()) {
      if (typeof window.gtag === "function") window.gtag("event", name, params);
      else if (typeof window.plausible === "function") window.plausible(name, { props: params });
      else if (Array.isArray(window.dataLayer)) window.dataLayer.push({ event: name, ...params });
    }
    window.dispatchEvent(new CustomEvent("elm:track", { detail: { name, params } }));
  } catch {
    /* jamais bloquant */
  }
};